(() => {
  function initializeMobileNavigation(root = document) {
    root.querySelectorAll('[data-wm-navigation]:not([data-wm-ready])').forEach((nav) => {
      nav.dataset.wmReady = 'true';
      const themeScroll = nav.querySelector('[data-wm-theme-scroll]');
      const themeProgress = nav.querySelector('[data-wm-theme-progress]');
      if (themeScroll && themeProgress) {
        const updateThemeProgress = () => {
          const total = themeScroll.scrollWidth;
          const visible = themeScroll.clientWidth;
          if (!total || !visible) return;
          const fraction = Math.min(1, visible / total);
          const maxScroll = Math.max(0, total - visible);
          const position = maxScroll ? Math.min(1, Math.max(0, themeScroll.scrollLeft / maxScroll)) : 0;
          themeProgress.style.setProperty('--wm-progress-width', (fraction * 100) + '%');
          themeProgress.style.setProperty('--wm-progress-offset', (position * (1 - fraction) * 100) + '%');
        };
        themeScroll.addEventListener('scroll', updateThemeProgress, { passive: true });
        const observer = new ResizeObserver(updateThemeProgress);
        observer.observe(themeScroll);
        nav.closest('.wm-drawer')?.addEventListener('transitionend', updateThemeProgress);
        updateThemeProgress();
      }
      const selectors = Array.from(nav.querySelectorAll('[data-wm-view]'));
      const panels = Array.from(nav.querySelectorAll('[data-wm-panel]'));
      selectors.forEach((button) => {
        button.addEventListener('click', () => {
          selectors.forEach((selector) => selector.setAttribute('aria-pressed', String(selector === button)));
          panels.forEach((panel) => { panel.hidden = panel.dataset.wmPanel !== button.dataset.wmView; });
          nav.closest('.drawer-content-filter').scrollTop = 0;
        });
      });
      nav.addEventListener('toggle', (event) => {
        const current = event.target;
        if (!current.matches('details.wm-group') || !current.open) return;
        const panel = current.closest('[data-wm-panel]');
        if (!panel) return;
        panel.querySelectorAll('details.wm-group[open]').forEach((details) => { if (details !== current) details.open = false; });
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeMobileNavigation());
  else initializeMobileNavigation();
  document.addEventListener('shopify:section:load', (event) => initializeMobileNavigation(event.target));
})();
